import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { Container } from 'containers/common/LegalProceedings/ExpertReport/styled-component';
import { Listings } from 'containers/AppContainer/typings';
import { LISTINGS, PROCEDURE_STATUSES } from 'containers/data-structure';
import { get, isEmpty } from 'lodash';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Recap/messages';
import { translate } from 'containers/services/translate';
import { EXPERTISE_FIELD } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';
import { shouldRenderExpertiseByType } from 'containers/common/LegalProceedings/ExpertReport/utils';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  ExpertReportType,
  IExpertGlobalReportState,
} from 'containers/common/LegalProceedings/ExpertReport/typings';
import ExpertiseType from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/ExpertiseType';
import ExpertiseVictims from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Victims';
import ExpertiseVehicules from 'containers/common/LegalProceedings/JudgementAdd/Recap/Pronouncing/Expertise/Vehicules';
import { showValidator } from 'containers/common/LegalProceedings/utils';
import ValidatorRecap from 'containers/common/LegalProceedings/ValidatorRecap';
import { COLORS } from 'constants/design';

import { getCurrentExpertise } from 'containers/common/LegalProceedings/ExpertReportAppeal/utils';

import { TYPE } from 'containers/common/LegalProceedings/ExpertReport/FormsByExpertiseType/constants';
import ExpertiseByType from 'containers/common/LegalProceedings/ExpertReport/ExpertiseByType';
import { Claim } from 'containers/PreOpeningPage/typings';
import { VictimType } from 'typings/globalTypes';

export interface ExpertReportAppealProps {
  intl: IntlShape;
  expertReportState: IExpertGlobalReportState[];
  listings: Listings;
  uploadDocument?: Function;
  uploadedDocument?: IUploadedDocument;
  resetUploadedDocument?: Function;
  documentId?: string;
  setDocumentId?: Function;
  claimId: number;
  readOnly?: boolean;
  isManager?: boolean;
  expertReport: ExpertReportType;
  setIsDecisionDialgOpen?: Function;
  setExpertReportState: Function;
  isDecisionDialgOpen?: boolean;
  validateVictimExpertise?: any;
  isAssignedLawyer: boolean;
  judiciaryProcessId?: number;
  isCreator?: boolean;
  deactivateButton?: any;
  setDeactivateButton?: Function;
  judgementAddDocuments: any;
  setIsSuccessPopinOpen?: Function;
  victimExpertises?: any;
  vehicleExpertises?: any;
  requestCreateExpertiseRaport?: Function;
  requestGetExpertiseRaport?: Function;
  requestValidateExpertReport?: Function;
  claimNumber: string;
  assignedLawyers?: string[];
  victims?: VictimType[];
  claim?: Claim;
  policyInfo?: any;
  hasJom?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isConsultation: Boolean;
  imagineDocuments: any;
  expertiseRaportFirstInstance?: any;
  dahirAmount?: any;
  requestGetDocByDocumentumId: Function;
}

export const ExpertReportAppeal: React.FC<ExpertReportAppealProps> = (
  props,
): JSX.Element => {
  const hasValidator = showValidator(
    get(props, 'expertReport.validator', ''),
    props.isManager || false,
  );

  return (
    <Container id="expert-report-wrapper">
      {get(props.expertReport, 'rejectionReason', '') &&
        get(props.expertReport, 'status', '') ===
          PROCEDURE_STATUSES.REJECTED && (
          <span className="pronouncing-title" style={{ color: COLORS.RED }}>
            {translate(messages.rejectedTitle, props)}
            {` : ${get(props.expertReport, 'rejectionReason', '')}`}
          </span>
        )}
      {hasValidator &&
        get(props, 'expertReport.status', '') !==
          PROCEDURE_STATUSES.PENDING && (
          <ValidatorRecap
            validator={get(props, 'expertReport.validator', '')}
          />
        )}
      {props.expertReportState.map((document, documentIndex) => (
        <div key={document.id}>
          <div className="pronouncing-title">
            {translate(messages.arret, props, {
              index: documentIndex + 1,
            })}
          </div>
          {document.expertises.map((expertise, expertiseIndex: number) => {
            return (
              <ExpertiseType
                expertiseId={expertise[EXPERTISE_FIELD.EXPERTISE_ID]}
                expertiseList={get(props.listings, LISTINGS.EXPERTISE, [])}
                index={expertiseIndex}
                key={expertiseIndex}
              >
                <>
                  {shouldRenderExpertiseByType(
                    expertise[EXPERTISE_FIELD.EXPERTISE_ID],
                  ).shouldRenderVictimFields && (
                    <ExpertiseVictims victims={expertise.victims}>
                      {expertise.victims
                        .filter(
                          (victim: any) =>
                            !isEmpty(get(victim, 'victimExpertise')),
                        )
                        .map((victim, victimIndex: number) => {
                          return (
                            <ExpertiseByType
                              expertReport={props.expertReport}
                              listings={props.listings}
                              documentId={props.documentId}
                              setDocumentId={props.setDocumentId}
                              uploadDocument={props.uploadDocument}
                              uploadedDocument={props.uploadedDocument}
                              resetUploadedDocument={
                                props.resetUploadedDocument
                              }
                              expertReportState={props.expertReportState}
                              setExpertReportState={props.setExpertReportState}
                              validateVictimExpertise={
                                props.validateVictimExpertise
                              }
                              isAssignedLawyer={props.isAssignedLawyer}
                              isCreator={props.isCreator}
                              deactivateButton={props.deactivateButton}
                              setDeactivateButton={props.setDeactivateButton}
                              judgementAddDocuments={
                                props.judgementAddDocuments
                              }
                              setIsSuccessPopinOpen={
                                props.setIsSuccessPopinOpen
                              }
                              expertise={expertise}
                              item={victim}
                              index={victimIndex}
                              documentIndex={documentIndex}
                              expertiseIndex={expertiseIndex}
                              expertiseType={TYPE.VICTIM}
                              currentExpertise={getCurrentExpertise(
                                props.victimExpertises,
                                props.vehicleExpertises,
                                victim.id,
                                expertise.expertiseId,
                                expertise.expertiseJudgementAddDocumentId,
                              )}
                              claimId={props.claimId}
                              requestCreateExpertiseRaport={
                                props.requestCreateExpertiseRaport
                              }
                              judiciaryProcessId={props.judiciaryProcessId}
                              claimNumber={props.claimNumber}
                              requestGetExpertiseRaport={
                                props.requestGetExpertiseRaport
                              }
                              requestValidateExpertReport={
                                props.requestValidateExpertReport
                              }
                              isAppeal
                              isRecap={false}
                              isManager={props.isManager}
                              setIsDecisionDialgOpen={
                                props.setIsDecisionDialgOpen
                              }
                              isDecisionDialgOpen={props.isDecisionDialgOpen}
                              assignedLawyers={props.assignedLawyers}
                              claim={props.claim}
                              victims={props.victims}
                              policyInfo={props.policyInfo}
                              hasJom={props.hasJom}
                              sagisVictimInfo={props.sagisVictimInfo}
                              sagisOpposingParties={props.sagisOpposingParties}
                              imagineDocuments={props.imagineDocuments}
                              expertiseRaportFirstInstance={
                                props.expertiseRaportFirstInstance
                              }
                              dahirAmount={props.dahirAmount}
                              requestGetDocByDocumentumId={
                                props.requestGetDocByDocumentumId
                              }
                            />
                          );
                        })}
                    </ExpertiseVictims>
                  )}
                  {shouldRenderExpertiseByType(
                    expertise[EXPERTISE_FIELD.EXPERTISE_ID],
                  ).shouldRenderVehiculeFields && (
                    <ExpertiseVehicules vehicules={expertise.vehicules}>
                      {expertise.vehicules
                        .filter(
                          (vehicule: any) =>
                            !isEmpty(get(vehicule, 'vehiculeExpertise')),
                        )
                        .map((vehicule, vehiculeIndex) => {
                          return (
                            <ExpertiseByType
                              expertReport={props.expertReport}
                              listings={props.listings}
                              documentId={props.documentId}
                              setDocumentId={props.setDocumentId}
                              uploadDocument={props.uploadDocument}
                              uploadedDocument={props.uploadedDocument}
                              resetUploadedDocument={
                                props.resetUploadedDocument
                              }
                              expertReportState={props.expertReportState}
                              setExpertReportState={props.setExpertReportState}
                              validateVictimExpertise={
                                props.validateVictimExpertise
                              }
                              isAssignedLawyer={props.isAssignedLawyer}
                              isCreator={props.isCreator}
                              deactivateButton={props.deactivateButton}
                              setDeactivateButton={props.setDeactivateButton}
                              judgementAddDocuments={
                                props.judgementAddDocuments
                              }
                              setIsSuccessPopinOpen={
                                props.setIsSuccessPopinOpen
                              }
                              expertise={expertise}
                              item={vehicule}
                              index={vehiculeIndex}
                              documentIndex={documentIndex}
                              expertiseIndex={expertiseIndex}
                              expertiseType={TYPE.VEHICLE}
                              currentExpertise={getCurrentExpertise(
                                props.victimExpertises,
                                props.vehicleExpertises,
                                vehicule.id,
                                expertise.expertiseId,
                                expertise.expertiseJudgementAddDocumentId,
                              )}
                              claimId={props.claimId}
                              requestCreateExpertiseRaport={
                                props.requestCreateExpertiseRaport
                              }
                              requestGetExpertiseRaport={
                                props.requestGetExpertiseRaport
                              }
                              requestValidateExpertReport={
                                props.requestValidateExpertReport
                              }
                              judiciaryProcessId={props.judiciaryProcessId}
                              claimNumber={props.claimNumber}
                              isAppeal
                              isManager={props.isManager}
                              isRecap={false}
                              setIsDecisionDialgOpen={
                                props.setIsDecisionDialgOpen
                              }
                              isDecisionDialgOpen={props.isDecisionDialgOpen}
                              assignedLawyers={props.assignedLawyers}
                              claim={props.claim}
                              victims={props.victims}
                              policyInfo={props.policyInfo}
                              hasJom={props.hasJom}
                              sagisVictimInfo={props.sagisVictimInfo}
                              sagisOpposingParties={props.sagisOpposingParties}
                              imagineDocuments={props.imagineDocuments}
                              expertiseRaportFirstInstance={
                                props.expertiseRaportFirstInstance
                              }
                              requestGetDocByDocumentumId={
                                props.requestGetDocByDocumentumId
                              }
                            />
                          );
                        })}
                    </ExpertiseVehicules>
                  )}
                </>
              </ExpertiseType>
            );
          })}
        </div>
      ))}
    </Container>
  );
};

export default injectIntl(ExpertReportAppeal);
